module.exports = __webpack_public_path__ + "img/glas_2.6972e36c.png";